import AdSlot from '../components/AdSlot';
import KeyboardList from '../components/KeyboardList';
import Layout from '../components/Layout';
import { MetaData, PageProps } from '../types';
import { getGlobalContext } from '../utils/context';

const h1 = 'Language Keyboard';
const meta: MetaData = {
  title: 'Language Keyboard',
  description:
    'Online keyboards for Arabic, Russian, Korean, Hebrew, Thai, Amharic and more, plus accents, Dvorak and Colemak. Type on your own keyboard and copy your text.',
  image: '/ogimage.png',
};

const HomePage = (props: PageProps) => {
  const { globalContext } = props;
  const { keyboardGroups } = globalContext;
  return (
    <Layout globalContext={globalContext} h1={h1} meta={meta} schemaType="WebSite">
      <p>
        Type in other languages and alphabets on your normal keyboard, or by clicking the keys on screen, then copy your
        text wherever you need it.
      </p>
      <p>
        I&apos;m always looking for new keyboards to add, so{' '}
        <a href="mailto:will@languagekeyboard.net">please send me any requests</a>.
      </p>
      <KeyboardList keyboardGroups={keyboardGroups} />
      <AdSlot />
    </Layout>
  );
};

export const getStaticProps = async () => ({ props: getGlobalContext() });

export default HomePage;
